import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request } from "../apiV2Request";

export const useBusinessUserInvite = (businessId: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: { email: string }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `businesses/${businessId}/invite`,
        data,
      }),
  });
};
